import React from 'react';
import { Navigate } from 'react-router-dom';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import QuestionView from './routes/QuestionView';
import { NAME, reducer } from './modules/Module';

const OnlineExamConfigLazy = React.lazy(
	() => import(/* webpackChunkName : 'OnlineExamConfig' */ './components')
);

export default (store) => {
	store.injectReducer(NAME, reducer);
	return {
		path: 'examgrading-setup/exam-setup/:campusId/:examId/online-exam-config/:configId',
		element: (
			<AsyncLoading
				component={
					<OnlineExamConfigLazy
						permission="CanViewExamGradingSetup"
						featureFlag="FeatureFlag:OnlineExams"
					/>
				}
			/>
		),
		children: [
			{ index: true, element: <Navigate to="intro" replace /> },
			QuestionView(),
		],
	};
};
